import React from 'react';
import { Box, Button } from 'rebass';

import NiceModal from 'components/NiceModal';
import { Portal } from 'components/Portal';

/**
 * Modal to delete branding
 *
 * @param {Function} onDelete Delete action
 * @param {Function} onClose Close action
 * @param {boolean} isOpen Modal open state
 */
export function DeleteBrandingModal({ onDelete, onClose, isOpen }) {
    return (
        <Portal>
            <NiceModal isOpen={isOpen} shouldCloseOnOverlayClick onRequestClose={onClose} title="Delete branding">
                <Box as="p" mb="24px" className="color-text-secondary">
                    This will permanently delete the branding. Are you sure you want to proceed?
                </Box>
                <Box className="modal-actions">
                    <Button type="button" mr={2} onClick={onClose} variant="secondary-gray">
                        Cancel
                    </Button>
                    <Button type="button" variant="danger-filled" mr={0} className="modal-primary" onClick={onDelete}>
                        Delete branding
                    </Button>
                </Box>
            </NiceModal>
        </Portal>
    );
}
